export default __webpack_public_path__ + "static/media/SlideNine.848a869a.png";